export default __webpack_public_path__ + "static/media/tms-rolling-stock.1c018291.pdf";